import React from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../components/common/breadcrumb.component";
import Export from "./export";
import "./applicationExport.css";

const ApplicationExport = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <Breadcrumb
        title={t("profile.applicationExport.title")}
        parent={t("profile.title")}
      />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="table-responsive">
              <Export />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ApplicationExport);
